import React from 'react';
import { Phone, Mail, MapPin, CreditCard } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Contact = () => {
  return (
    <section id="contact" className="py-6 bg-gradient-to-b from-amber-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-4">
          <h2 className="text-2xl md:text-3xl font-bold text-amber-900 mb-1">
            Get in Touch
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm">
            Contact us to learn more or make a reservation.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-4xl mx-auto">
          {/* Phone */}
          <div className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-all border border-amber-100 text-center group">
            <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-2 group-hover:bg-amber-600 transition-colors">
              <Phone className="text-amber-700 group-hover:text-white transition-colors" size={18} />
            </div>
            <h3 className="text-sm font-semibold text-gray-900 mb-1">Phone</h3>
            <a 
              href={`tel:${businessInfo.phone}`}
              className="text-amber-700 hover:text-amber-800 font-medium text-sm"
            >
              {businessInfo.phone}
            </a>
          </div>

          {/* Email */}
          <div className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-all border border-amber-100 text-center group">
            <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-2 group-hover:bg-amber-600 transition-colors">
              <Mail className="text-amber-700 group-hover:text-white transition-colors" size={18} />
            </div>
            <h3 className="text-sm font-semibold text-gray-900 mb-1">Email</h3>
            <a 
              href={`mailto:${businessInfo.email}`}
              className="text-amber-700 hover:text-amber-800 font-medium transition-colors text-sm break-all"
            >
              {businessInfo.email}
            </a>
          </div>

          {/* Location */}
          <div className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-all border border-amber-100 text-center group">
            <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-2 group-hover:bg-amber-600 transition-colors">
              <MapPin className="text-amber-700 group-hover:text-white transition-colors" size={18} />
            </div>
            <h3 className="text-sm font-semibold text-gray-900 mb-1">Visit Us</h3>
            <p className="text-gray-600 text-xs">
              Marina Homes
            </p>
          </div>

          {/* Payment */}
          <div className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-all border border-green-100 text-center group">
            <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2 group-hover:bg-green-600 transition-colors">
              <CreditCard className="text-green-700 group-hover:text-white transition-colors" size={18} />
            </div>
            <h3 className="text-sm font-semibold text-gray-900 mb-1">M-Pesa</h3>
            <p className="text-green-700 font-bold text-sm">351410134</p>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-4 text-center bg-gradient-to-r from-amber-600 to-amber-700 rounded-lg p-4">
          <h3 className="text-lg font-bold text-white mb-1">
            Ready to Book Your Stay?
          </h3>
          <p className="text-amber-100 text-xs mb-3">
            Contact us today and let us make your stay unforgettable.
          </p>
          <div className="flex items-center justify-center gap-2">
            <a 
              href={`tel:${businessInfo.phone}`}
              className="bg-white text-amber-700 px-4 py-1.5 rounded-lg font-semibold text-xs transition-all hover:scale-105 shadow"
            >
              Call Now
            </a>
            <a 
              href={`mailto:${businessInfo.email}`}
              className="bg-amber-800 text-white px-4 py-1.5 rounded-lg font-semibold text-xs transition-all hover:scale-105 shadow"
            >
              Email Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
